import { useEffect, useState, useMemo, useRef } from 'react';
import axiosInstance from '../../API/axiosInstance';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Bounce, ToastContainer } from 'react-toastify';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { FiPlus } from 'react-icons/fi';
import 'react-circular-progressbar/dist/styles.css';
import './userTask.css';
import FAQ from '../../ui_components/faq_component/FAQ';
import DownloadAppUI from '../../ui_components/download_app/download_app';
import SiteFooter from '../../ui_components/site_footer/site_footer';

const UserTask = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);
  const [userId, setUserId] = useState(null);
  const [membership, setMembership] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [taskTitle, setTaskTitle] = useState('');
  const [task, setTask] = useState('');
  const [checked, setChecked] = useState(false);
  const PHASE_ORDER = [
    '12 – 9 Months Before',
    '9 – 6 Months Before',
    '6 – 4 Months Before',
    '3 – 2 Months Before',
    '1 Month Before',
    'Wedding Week',
    'Post-Wedding',
    'custom'
  ];


  const [completedTasksCount, setCompletedTasksCount] = useState(0);
  const [totalTasksCount, setTotalTasksCount] = useState(0);
  const [progress, setProgress] = useState(0);

  const taskContainerRef = useRef(null);

  const groupedTasks = useMemo(() => {
    let total = 0;
    let completed = 0;
    // create a map → { phase: [tasks …] }
    const map = {};
    tasks.forEach(t => {
      total++;
      if (t.completed) completed++;
      const p = t.phase || 'Un-categorised';
      if (!map[p]) map[p] = [];
      map[p].push(t);
    });

    setCompletedTasksCount(completed);
    setTotalTasksCount(total);
    setProgress(Math.round((completed / total) * 100));
    // return an array sorted by our PHASE_ORDER
    return PHASE_ORDER
      .filter(p => map[p])          // keep phases that exist in data
      .map(p => ({ phase: p, items: map[p] }));
  }, [tasks]);


  useEffect(() => {
    const fetchToken = () => {
      const storedToken = localStorage.getItem("token");
      if (storedToken) {
        setToken(storedToken);
      }
    }

    const fetchUser = () => {
      const storedUser = localStorage.getItem("currentUser");
      if (storedUser) {
        const user = JSON.parse(storedUser);
        setUserId(user.id);
        setMembership(user.planType);
      }
    };

    fetchToken();
    fetchUser();
  }, []);

  useEffect(() => {
    if (userId && token) {
      axiosInstance.get(`/tasks/all-tasks-with-status/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then(res => {
          setTasks(res.data);
          setLoading(false);
        })
        .catch(err => {
          console.error("Failed to fetch tasks:", err);
          setLoading(false);
        });
    }
  }, [userId, token]);


  if (loading) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border text-primary" role="status" />
      </div>
    );
  }


  const saveNewTask = async () => {
    try {
      const response = await axiosInstance.post('/tasks/create', {
        title: taskTitle,
        task: task,
        phase: 'custom',
        createdBy: userId,
        type: 'custom',
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200 || response.status === 201) {
        setTasks(prev => [...prev, response.data]);
        setTaskTitle('');
        setShowModal(false);
        notify('success', 'task created successfully');
      }
    } catch (error) {
      console.error("Failed to save task:", error);
    }
  };


  const markTaskStatus = async (taskId, nextCompleted, isCompleted) => {

    if (isCompleted == false) {
      try {
        const { status } = await axiosInstance.post('/tasks/mark-complete',
          {
            "userId": userId,
            "taskId": taskId,
            "completed": !isCompleted
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (status === 200 || status === 201) {
          notify('success', 'Task marked as completed');
          setTasks(prev =>
            prev.map(t =>
              t.id === taskId ? { ...t, completed: nextCompleted } : t
            )
          );
        }
        else {
          notify('error', 'Something went wrong!');
        }
      } catch (err) {
        console.error('Failed to update task status:', err.response?.data || err);
      }
    }
    else {
      try {
        const { status } = await axiosInstance.delete(`/tasks/${taskId}/completion?userId=${userId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (status === 204) {
          notify('success', 'Task marked as pending');
          setTasks(prev =>
            prev.map(t =>
              t.id === taskId ? { ...t, completed: nextCompleted } : t
            )
          );
        }
        else {
          notify('error', 'Something went wrong!');
        }
      } catch (err) {
        console.error('Failed to update task status:', err.response?.data || err);
      }
    }

  };

  const notify = (status, msg) => {
    (status == "success") ? (toast.success(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
    })) : ((toast.error(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
    })))
  };

  const MyCircularProgress = ({ percentage }) => {
    // Decide color based on percentage
    const getColor = (percentage) => {
      if (percentage >= 80) return '#28a745';         // Green
      if (percentage >= 30) return '#ffc107';         // Yellow
      return '#dc3545';                               // Red
    };

    const fillColor = getColor(percentage);

    return (
      <div className='progress-bar-container'>
        <div className='progress-bar me-2'>
          <div
            className='progress-fill'
            style={{ width: `${percentage}%`, backgroundColor: fillColor }}
          ></div>
        </div>

        <div>
          <span className='progress-percentage'>{percentage}%</span>
        </div>
      </div>
    );
  };


  const handleScrollToEnd = () => {
  setTimeout(() => {
    const el = taskContainerRef.current;
    if (el) {
      el.scrollLeft = el.scrollWidth;
    }
  }, 0); // waits until DOM is updated
};



  return (
    <>
    <section className='task-main-container container my-3'>
      <div className='fluid-container task-container ' >
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={true}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Bounce}
        />
        <section className='headder-section'>
          <section>
            <h1>Task Boards</h1>
            <h4><span style={{ fontSize: '40px' }}>{completedTasksCount}</span>/{totalTasksCount}</h4>
          </section>
          {membership === 'PREMIUM' &&
            <section className='buttons-section'>
              <button className='btn btn-outline-secondary me-2' onClick={handleScrollToEnd}>
                View Custom task
              </button>

              <button className='btn btn-primary d-flex align-items-center gap-2' onClick={() => setShowModal(true)}>
                <FiPlus />
                Add Custom Task
              </button>
            </section>}
        </section>


        <section className='progress-section mt-3'>
          <MyCircularProgress percentage={progress} />
        </section>


        <hr></hr>
        <section ref={taskContainerRef} className="tasks-container">
          <div className="phase-scroll-wrapper">
            {groupedTasks.map(({ phase, items }) => (
              <div className="phase-column" key={phase}>
                <div className="phase-header">{phase}</div>

                <ul className="task-list">
                  {items.map(task => (
                    <li key={task.id} className="task-tile">
                      <div className="left">
                        <input
                          className="form-check-input me-2 Success-checkbox"
                          type="checkbox"
                          value={task.id}
                          onChange={e => markTaskStatus(task.id, e.target.checked, task.completed)}
                          checked={task.completed}
                        />
                        <div>
                          <strong style={{ textDecoration: task.completed ? 'line-through' : 'none' }}>
                            {task.task}
                          </strong>

                        </div>
                      </div>
                      <span className={`badge ${task.completed ? 'bg-success' : 'bg-secondary'}`}>
                        {task.completed ? 'Completed' : 'Pending'}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
        {membership === 'PREMIUM' && (
          <>
            {/* Modal */}
            {showModal && (
              <div className="modal d-block" tabIndex="-1" onClick={() => setShowModal(false)} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                <div className="modal-dialog" onClick={e => e.stopPropagation()}>
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Add New Task</h5>
                      <button type="button" className="btn-close" onClick={() => setShowModal(false)} />
                    </div>
                    <div className="modal-body">
                      <div className="mb-3">
                        <label htmlFor="taskTitle" className="form-label">Task Title</label>
                        <input
                          type="text"
                          className="form-control"
                          id="taskTitle"
                          placeholder="Enter task title"
                          value={taskTitle}
                          onChange={e => setTaskTitle(e.target.value)}
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="task" className="form-label">Task</label>
                        <input
                          type="text"
                          className="form-control"
                          id="taskTitle"
                          placeholder="Enter task title"
                          value={task}
                          onChange={e => setTask(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                      <button className="btn btn-primary" onClick={saveNewTask}>Save Task</button>
                    </div>
                  </div>
                </div>
              </div>

            )}
          </>
        )}
      </div>

      <section className="my-5">
        {/* FAQ */}
        <div>
          <FAQ />
        </div>
        {/* Download the app */}
        <div id='download-app-container' className='m-0'>
          <DownloadAppUI />
        </div>

        {/* Site Footer */}
        <div>
          <SiteFooter />
        </div>
      </section>
    </section>

    </>

  );
};

export default UserTask;
